export default __webpack_public_path__ + "static/pict7Placeholder-5760bc4e6d37963533158847e1058fbe.png";